<template>
  <v-container fluid>
    <back-link-component :to="{ name: 'RefLineListAsList' }" :label="$tt('customRefLine')" />
    <v-row align-center justify-space-between v-if="refLine">
      <v-col cols="12" md="5">
        <v-sheet color="grey lighten-4" class="px-4 pb-8 pt-4">
          <v-layout align-center justify-start>
            <!-- 基準線名 -->
            <v-sheet class="transparent">
              <h1 class="pl-3">
                {{ getRefLineName(refLine) }}
              </h1>
            </v-sheet>

            <v-icon left class="pl-2" v-if="isMyRefLine(refLine)" @click="showMetaDataEditor()">mdi-pencil</v-icon>
          </v-layout>

          <!-- 日時 -->
          <v-sheet class="transparent pl-3">
            <span class="subtitle-1 font-weight-bold">
              {{ refLine.createdDateTime | aidToYearMonthDayHourMin }}
            </span>
          </v-sheet>

          <!-- 圃場 -->
          <v-sheet class="transparent pl-2">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-icon large>place</v-icon>
                {{ getFieldNameFromFieldGeoInfoKeyFromRefLine(refLine) }}
                <v-icon
                  left
                  class="pl-2"
                  v-if="getFieldFromGeoInfoKeyFromRefLine(refLine)"
                  @click="showFieldDetail(refLine)"
                >
                  mdi-pencil
                </v-icon>
              </v-col>
            </v-row>
          </v-sheet>
          <v-sheet class="transparent px-2 pt-4">
            <div class="font-weight-bold mb-0">
              <user-icon-component
                class="pr-2"
                size="60"
                :showNickname="true"
                :iconUrl="getAccount(refLine).iconUrl"
                :nickname="getAccount(refLine).nickname"
              />
              {{ getAccount(refLine).nickname }}
            </div>
          </v-sheet>
          <v-row no-gutters class="px-4 pt-8">
            <v-col cols="12">
              <v-divider />
              <!-- 種別 -->
              <v-row>
                <v-col cols="6" class="py-2">
                  <v-layout align-center justify-start>
                    <v-sheet width="32" class="transparent">
                      <v-img src="/icons/ReferenceLine_type.png" />
                    </v-sheet>
                    <v-sheet class="ml-2 font-weight-bold  subtitle-2 transparent">{{ $tt('customType') }}</v-sheet>
                  </v-layout>
                </v-col>
                <v-col cols="6" class="py-2">
                  <v-sheet class="ml-2 font-weight-bold text-right subtitle-2 transparent">
                    {{ getTypeAsString(refLine) }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider />
              <!-- ガイダンス間隔 -->
              <v-row>
                <v-col cols="6" class="py-2">
                  <v-layout align-center justify-start>
                    <v-sheet width="32" class="transparent">
                      <v-img src="/icons/ReferenceLine_width.png" />
                    </v-sheet>
                    <v-sheet class="ml-2 font-weight-bold  subtitle-2 transparent">
                      {{ $tt('customGuidanceInterval') }}
                    </v-sheet>
                  </v-layout>
                </v-col>
                <v-col cols="6" class="py-2">
                  <v-sheet class="ml-2 font-weight-bold text-right subtitle-2 transparent">
                    {{ getGuidanceIntervalAsString(refLine) }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider />
              <!-- 方位 -->
              <v-row>
                <v-col cols="6" class="py-2">
                  <v-layout align-center justify-start>
                    <v-sheet width="32" class="transparent">
                      <v-img width="15" class="ml-2" src="/icons/ReferenceLine_direction.png" />
                    </v-sheet>
                    <v-sheet class="ml-2 font-weight-bold  subtitle-2 transparent">
                      {{ $tt('customDirecton') }}
                    </v-sheet>
                  </v-layout>
                </v-col>
                <v-col cols="6" class="py-2">
                  <v-sheet class="ml-2 font-weight-bold text-right subtitle-2 transparent">
                    {{ getDirectionAsString(refLine) }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider />
              <!-- 走行基準線長 -->
              <v-row>
                <v-col cols="6" class="py-2">
                  <v-layout align-center justify-start>
                    <v-sheet width="32" class="transparent">
                      <v-img src="/icons/ReferenceLine_length.png" />
                    </v-sheet>
                    <v-sheet class="ml-2 font-weight-bold  subtitle-2 transparent">
                      {{ $tt('customRefLineLength') }}
                    </v-sheet>
                  </v-layout>
                </v-col>
                <v-col cols="6" class="py-2">
                  <v-sheet class="ml-2 font-weight-bold text-right subtitle-2 transparent">
                    {{ getLineLengthAsString(refLine) }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider />
              <!-- 備考 -->
              <v-row>
                <v-col cols="5" class="py-2">
                  <v-layout align-center justify-start>
                    <v-sheet width="32" class="transparent">
                      <v-img src="/icons/WorkHistory_icon_note.png" />
                    </v-sheet>
                    <v-sheet class="ml-2 font-weight-bold  subtitle-2 transparent">
                      {{ $tt('DocFormFieldDetailDescriptionHint') }}
                    </v-sheet>
                    <v-icon left class="pl-2" v-if="isMyRefLine(refLine)" @click="showMetaDataEditor()">
                      mdi-pencil
                    </v-icon>
                  </v-layout>
                </v-col>
                <v-col cols="7" class="pb-2 pt-3">
                  <v-sheet class="ml-2 font-weight-regular text-left subtitle-2 transparent">
                    {{ refLine.caption }}
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider />
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="7" style="position:relative;" width="auto">
        <gmap-map
          ref="googleMapRef"
          :center="center"
          :zoom="zoomLevel"
          :options="{
            streetViewControl: false,
            rotateControl: false,
            gestureHandling: 'greedy',
            mapTypeControlOptions: {
              position: 2,
            },
            mapId: vectorMapId,
          }"
          map-type-id="roadmap"
          style="height: 70vh"
        >
          <GmapMarker :key="index" v-for="(marker, index) in refPointMarkers" :position="marker.position"
          :icon="marker.icon" optimized: false />
        </gmap-map>
      </v-col>
    </v-row>
    <v-dialog v-model="isShowMetaDataEditer" max-width="550px" persistent>
      <v-card class="pt-4">
        <v-card-text>
          <v-text-field
            v-model="editName"
            :label="$tt('customRefLineNameHint')"
            :placeholder="$tt('customRefLineNameHint')"
          />
          <v-textarea
            v-model="editCaption"
            :label="$tt('DocFormFieldDetailDescriptionHint')"
            :placeholder="$tt('DocFormFieldDetailDescriptionHint')"
            rows="2"
            auto-grow
          />
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="secondary" @click="closeMetaDataEditor()">
            {{ $tt('customCancel') }}
          </v-btn>
          <v-btn color="primary" @click="updateRefLineMetaData()">
            {{ $tt('customSaveAction') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <now-loading-overlay-component :nowLoading="nowLoading" />
  </v-container>
</template>

<script>
import FieldNameMixin from '@/components/mixins/field-name-mixin'
import MapMixin from '@/components/mixins/map-mixin'
import RefLineMixin from '@/components/mixins/ref-line-mixin'
import GoogleMapMixin from '@/components/mixins/google-map-mixin'
import UserIconComponent from '@/components/user/UserIconComponent'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'
import * as Constants from '@/lib/constants'
import CurveRefLine from '@/lib/geo/curve-ref-line'
import StraightRefLine from '@/lib/geo/straight-ref-line'
import UserInfo from '@/lib/user-info'

export default {
  name: 'RefLineDetail',
  mixins: [MapMixin, RefLineMixin, FieldNameMixin, GoogleMapMixin],
  data() {
    return {
      refLineGeoObject: null,
      startPointMarker: null,
      endPointMarker: null,
      startPointCoordinates: [0, 0],
      endPointCoordinates: [0, 0],
      isShowMetaDataEditer: false,
      editName: null,
      editCaption: null,
      aidGreen: Constants.CONNECT_GREEN,

      center: { lat: 10, lng: 10 },
      startMarker: {
        position: { lat: 0, lng: 0 },
        icon: {
          url: '/images/RefPointA.png',
          scaledSize: null,
        },
      },
      endMarker: {
        position: { lat: 0, lng: 0 },
        icon: {
          url: '/images/RefPointB.png',
          scaledSize: null,
        },
      },
      refPointMarkers: [],
      nowLoading: false,
    }
  },
  components: {
    UserIconComponent,
    NowLoadingOverlayComponent,
  },
  computed: {
    refLine() {
      return this.$store.getters.currentRefLine
    },
    refLineGeoJson() {
      return this.$store.getters.currentRefLineGeoJson
    },
    isStraight() {
      return 'Straight' === this.$store.getters.currentRefLine.refLineType
    },
  },
  mounted() {
    this.checkAvailabilityBeforeMount()
    if (this.isStraight) {
      this.refLineGeoObject = new StraightRefLine(this.refLineGeoJson)
    } else {
      this.refLineGeoObject = new CurveRefLine(this.refLineGeoJson)
    }
    this.refLineGeoObject.prepare(this.refLine.guidanceInterval)
    this.startPointCoordinates = this.refLineGeoObject.startPointCoordinates
    this.endPointCoordinates = this.refLineGeoObject.endPointCoordinates

    this.$store.dispatch('setFieldGeoJsons', { type: 'FeatureCollection', features: [] })
    this.drawAllFieldsOnGoogleMap()

    this.center.lat = this.refLineGeoObject.startPointCoordinates[1]
    this.center.lng = this.refLineGeoObject.startPointCoordinates[0]
    this.startMarker.position.lat = this.startPointCoordinates[1]
    this.startMarker.position.lng = this.startPointCoordinates[0]

    this.endMarker.position.lat = this.endPointCoordinates[1]
    this.endMarker.position.lng = this.endPointCoordinates[0]

    this.refPointMarkers.push(this.startMarker)
    this.refPointMarkers.push(this.endMarker)

    let redMultiLineGeoJson = this.refLineGeoObject.redMultiLineGeoJson
    let blueMultiLineGeoJson = this.refLineGeoObject.blueMultiLineGeoJson
    let baseLineGeoJson = this.refLineGeoObject.refLineGeoJson
    redMultiLineGeoJson.properties.type = Constants.GeoFeaturePropertiesType.RED
    blueMultiLineGeoJson.properties.type = Constants.GeoFeaturePropertiesType.BLUE

    baseLineGeoJson.features.forEach(feature => {
      feature.properties.type = Constants.GeoFeaturePropertiesType.BASE
    })

    this.$refs.googleMapRef.$mapPromise.then(map => {
      map.setTilt(0)
      this.startMarker.icon.scaledSize = new google.maps.Size(50, 50)
      this.endMarker.icon.scaledSize = new google.maps.Size(50, 50)
      this.startMarker.icon.anchor = new google.maps.Point(25, 25)
      this.endMarker.icon.anchor = new google.maps.Point(25, 25)
      map.data.addGeoJson(this.refLineGeoObject.refLineGeoJson)

      map.data.addGeoJson(redMultiLineGeoJson)
      map.data.addGeoJson(blueMultiLineGeoJson)
      map.data.addGeoJson(this.$store.getters.fieldGeoJsons)

      let bounds = new google.maps.LatLngBounds()
      map.data.forEach(feature => {
        const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)
        if (type === Constants.GeoFeaturePropertiesType.BASE) {
          feature.getGeometry().forEachLatLng(latlng => {
            bounds.extend(latlng)
          })
        }
      })

      map.data.setStyle(feature => {
        const type = feature.getProperty(Constants.GeoFeaturePropertiesType.TYPE)

        if (type === Constants.GeoFeaturePropertiesType.RED) {
          return {
            fillColor: 'red',
            strokeColor: 'red',
            strokeWeight: 2,
          }
        } else if (type === Constants.GeoFeaturePropertiesType.BLUE) {
          return {
            fillColor: 'blue',
            strokeColor: 'blue',
            strokeWeight: 2,
          }
        } else if (type === Constants.GeoFeaturePropertiesType.FIELD) {
          return {
            fillColor: Constants.FIELD_FILL_COLOR,
            fillOpacity: Constants.FIELD_FILL_OPACITY,
            strokeColor: Constants.FIELD_FILL_COLOR,
            strokeWeight: 1,
            zIndex: 0,
          }
        } else {
          return {
            strokeColor: 'red',
            strokeOpacity: 0,
            icons: [
              {
                icon: {
                  path: 'M -0.5,1.5 1,1.5',
                  strokeOpacity: 1,
                },
                offset: '0',
                repeat: '10px',
              },
            ],
          }
        }
      })
      map.fitBounds(bounds)
    })
  },
  methods: {
    getFieldFromGeoInfoKeyFromRefLine(refline) {
      if (UserInfo.isFSMigrated()) {
        return this.getFieldFromId(refline.fieldItemId)
      } else {
        return this.getFieldFromGeoInfoKey(refline.fieldItemKey)
      }
    },
    showFieldDetail(refline) {
      const field = this.getFieldFromGeoInfoKeyFromRefLine(refline)
      if (field) {
        this.$store.dispatch('getAllFields')
        this.$store.dispatch('showFieldDetail2', field)
      }
    },
    updateRefLineMetaData() {
      const updateRequest = {
        refLine: this.refLine,
        name: this.editName,
        caption: this.editCaption,
        geoJson: this.refLineGeoJson,
        onSuccess: this.updateRefLineMetaDataSuccess,
        onFailure: this.updateRefLineMetaDataFailure,
      }
      this.openNowLoading()
      this.$store.dispatch('updateRefLineMetaData', updateRequest)
      this.closeMetaDataEditor()
    },
    updateRefLineMetaDataSuccess() {
      this.closeMetaDataEditor()
      this.closeNowLoading()
    },
    updateRefLineMetaDataFailure() {
      this.closeMetaDataEditor()
      this.closeNowLoading()
    },
    openNowLoading() {
      this.nowLoading = true
    },
    closeNowLoading() {
      this.nowLoading = false
    },
    showMetaDataEditor() {
      this.editName = this.refLine.name
      this.editCaption = this.refLine.caption
      this.isShowMetaDataEditer = true
    },
    closeMetaDataEditor() {
      this.editName = null
      this.editCaption = null
      this.isShowMetaDataEditer = false
    },
  },
}
</script>
